import { EPosition, SummitFormattedText } from '@summit/models';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Company } from '../../organization/company/company';
import { LocationSource } from '../location/location-source.enum';
import { State } from '../state/state';
import { PlotTerminal } from './plot-terminal';
import { PlotType } from './plot-type.enum';

export class Plot extends EboNameObject {
  //Company Information
  companyId: string;
  company: Company;
  abbreviation: string;
  locationNum: number;

  //Owner Information
  ownerName: string;
  isOwnerOccupied: boolean;

  //Address Block -- Not complex due to State FK
  addr_Description: string; //Exit 140 on I-80
  addr_Line1: string;
  addr_Line1_PlatOverride: string;
  addr_Line2: string;
  addr_City: string;
  addr_StateId: string;
  addr_State: State;
  addr_Country: string;
  addr_PostalCode: string;
  addr_Point: EPosition;

  //Classification
  propertyType: PlotType;
  source: LocationSource;

  //Contact Information
  phoneNumber: string;
  faxNumber: string;
  url: string;

  //Amenities
  showerCount: number;
  fuelGasolineAvailable: boolean;
  fuelDieselAvailable: boolean;
  defLanes: number;
  fuelPropaneAvailable: boolean;
  fuelNaturalGasAvailable: boolean;
  fuelElectricAvailable: boolean;
  tractorParkingSpots: number;
  trailerParkingSpots: number;
  geometry: EPosition[];
  geometrySource: LocationSource;

  propertyTerminals: PlotTerminal[];

  //for export
  centroid: EPosition;
  radius: number;

  constructor(jsonData?: Partial<Plot>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.addr_State) {
        this.addr_State = new State(jsonData.addr_State);
      }
      if (jsonData.addr_Point) {
        this.addr_Point = new EPosition(jsonData.addr_Point);
      }
      if (jsonData.geometry) {
        this.geometry = jsonData.geometry.map((data) => new EPosition(data));
      }
      if (jsonData.propertyTerminals) {
        this.propertyTerminals = jsonData.propertyTerminals.map((x: PlotTerminal) => new PlotTerminal(x));
      }
    }
    this.source ??= LocationSource.Manual;
    this.fuelGasolineAvailable ??= false;
    this.fuelDieselAvailable ??= false;
    this.fuelPropaneAvailable ??= false;
    this.fuelNaturalGasAvailable ??= false;
    this.fuelElectricAvailable ??= false;
    this.isOwnerOccupied ??= false;
    this.geometry ??= [];
  }

  private _address: SummitFormattedText;
  get address(): SummitFormattedText {
    if (!this._address) {
      this._address = new SummitFormattedText();
      this._address.AddLine(this.addr_Description, ['font-bold', 'flex', 'justify-center', 'align-items-center']);
      this._address.AddLine(this.addr_Line1);
      if (this.addr_Line2) {
        this._address.AddLine(this.addr_Line2);
      }
      if (this.addr_City)
        this._address.AddLine(`${this.addr_City}, ${this.addr_State.abbreviation ?? '??'} ${this.addr_PostalCode}`);
      else if (this.addr_StateId)
        this._address.AddLine(`${this.addr_State.abbreviation ?? '??'} ${this.addr_PostalCode}`);
      else if (this.addr_PostalCode) this._address.AddLine(this.addr_PostalCode);
    }
    return this._address;
  }

  get hasBoundary(): boolean {
    return this.geometry?.length > 0;
  }
}
